export const calendarSurfaceSx = {
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 2,
  bgcolor: "background.paper",
  boxShadow: "none",
};
